import { GetterTree } from 'vuex';
import { State } from './state';
import { RootState } from '@/store';
import { GET_FUNCTIONALITY_LIST, GET_REGISTER_FUNCTIONALITY_FORM_VISIBILITY, GET_SELECTED_FUNCTIONALITY, GET_GROUPED_FUNCTIONALITY_LIST} from './types';

export const getters: GetterTree<State, RootState> = {
    [GET_FUNCTIONALITY_LIST](state: State) {
        return state.functionalities;
    },
    [GET_REGISTER_FUNCTIONALITY_FORM_VISIBILITY](state: State) {
        return state.showRegisterForm;
    },
    [GET_SELECTED_FUNCTIONALITY](state: State) {
        return state.functionalitySelected;
    },
    [GET_GROUPED_FUNCTIONALITY_LIST](state: State) {
        return state.groupedFunctionalities;
    },
};
